export default "__VITE_ASSET__ZeyRhUh6__"